import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { debounceTime, throttleTime } from 'rxjs/operators';
import { Subject } from 'rxjs/internal/Subject';
import { Subscription } from 'rxjs/internal/Subscription';
import { asyncScheduler } from 'rxjs';
import { LoadingTask } from '../ui/loading-task';

@Directive({
    selector: '[appPreventDoubleClick]',
    standalone: false
})
export class PreventDoubleClickDirective implements OnInit, OnDestroy {
  // @Input()
  private throttleTime = 300;

  @Output()
  throttledClick = new EventEmitter();

  private clicks = new Subject();
  private subscription: Subscription;

  constructor(private loadingTask: LoadingTask) { }

  ngOnInit() {
    this.subscription = this.clicks.pipe(
      throttleTime(this.throttleTime)
    ).subscribe((e: PointerEvent) => this.emitThrottledClick(e));
  }

  emitThrottledClick(e: PointerEvent) {
    if (!this.loadingTask.IsLoading) {
      this.throttledClick.emit(e);
      // (e.currentTarget as any).disabled = false;

    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @HostListener('click', ['$event'])
  clickEvent(event: PointerEvent) {
    // (event.currentTarget as any).disabled = true;
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }

  // @HostListener('document:keyup', ['$event'])
  // onKeydownHandler(event: KeyboardEvent) {
  //   if (event.key === 'Enter') {
  //     event.preventDefault();
  //     event.stopPropagation();
  //     this.clicks.next(event);
  //   }
  // }
}
